<div style="width: 40%; float: left">
	<!---------------------------->
	<!--Select Option-->
	<!---------------------------->
	<form [formGroup]="formGroup">
		<mat-grid-list cols="1" rowHeight="75px">
			<mat-grid-tile>
				<mat-form-field class="w-80">
					<mat-label>Provider Role</mat-label>
					<mat-select [formControlName]="controls.PROVIDER_ROLE">
						<mat-option *ngFor="let providerRole of providerRolesLookUpValues"
												[value]="providerRole.value">
							{{providerRole.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Provider Role')">help_outline</mat-icon>
			</mat-grid-tile>
			<!-- Provider Name-->
			<mat-grid-tile>
				<mat-form-field class="w-80">
					<mat-label>Provider Name</mat-label>
					<input type="text" matInput
								 [formControlName]="controls.PROVIDER_NAME"
								 (input)="byNameOrByBusinessLicenseNumberTextChanged$.next($any($event.target).value)"
								 (blur)="onBlur($event)"
								 [matAutocomplete]="primaryDiagnosisAuto"
					/>
					<mat-autocomplete #primaryDiagnosisAuto="matAutocomplete">
						<mat-option *ngFor="let provider of filteredProviders"
												[value]="getProviderDisplayString(provider)"
												(onSelectionChange)="onProviderSelected(provider)">
							{{ getProviderDisplayString(provider) }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Provider Name')">help_outline</mat-icon>
			</mat-grid-tile>
			<!-- Start Date-->
			<mat-grid-tile>
				<mat-form-field class="w-80">
					<mat-label>Start Date</mat-label>
					<input [formControlName]="controls.START_DATE"
								 [matDatepicker]="startDatePicker"
								 matInput />
					<mat-datepicker-toggle [for]="startDatePicker" matIconSuffix>
					</mat-datepicker-toggle>
					<mat-datepicker #startDatePicker></mat-datepicker>
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Provider Start Date')">help_outline</mat-icon>
			</mat-grid-tile>
			<mat-grid-tile>
				<button
					class="w-50"
					mat-raised-button
					color="primary"
					(click)="onAddProvider()">
					Add
				</button>
			</mat-grid-tile>
		</mat-grid-list>
	</form>
</div>
<div style="width: 55%; float: right">
	<!---------------------------->
	<!--Select Option-->
	<!---------------------------->
	<!-- Header -->
	<div class="flex-row">
		<div class="flex-item">
			<p class="mat-primary-color">Start date</p>
		</div>
    <div class="flex-item">
			<p class="mat-primary-color">Status</p>
		</div>
		<div class="flex-item">
			<p class="mat-primary-color">Role</p>
		</div>
		<div class="flex-item-extra">
			<p class="mat-primary-color">Name</p>
		</div>
		<div class="flex-item">
			<p class="mat-primary-color">Number</p>
		</div>
    <div class="flex-item">
			<p class="mat-primary-color">Network</p>
		</div>
		<!---------------------------->
		<!-- Empty Placeholder-->
		<!---------------------------->
		<div></div>
	</div>
	<!-- Body -->
	<ng-container *ngFor="let item of caseHospitalProviders; let idx = index">
		<div class="flex-row">
			<div class="flex-item">
				{{ item.startDate | date: dateFormat }}
			</div>
      <div class="flex-item">
				{{ item.provider?.entityStatus?.name }}
			</div>
			<div class="flex-item">
				{{ item.providerRole?.name }}
			</div>
			<div class="flex-item-extra">
				{{ item.provider?.name }}
			</div>
			<div class="flex-item">
				{{ item.provider?.practiceNumber }}
			</div>
      <div class="flex-item">
				{{ item.provider?.providerNetworkList }}
			</div>
			<div>
				<div class="flex-row">
					<div class="flex-item">
						<mat-icon
							class="info-icon hand-cursor"
							(click)="showSelectedProviderDialog(item?.provider)">
							visibility
						</mat-icon>
					</div>
					<div class="flex-item">
						<mat-icon class="mat-primary-color hand-cursor"
											(click)="onDeleteProvider($event, item)">delete</mat-icon>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>
<!---------------------------->
<!--Navigation Buttons-->
<!---------------------------->
<div class="button-container">
	<button color="primary" mat-raised-button matStepperPrevious>Back</button>
	<button (click)="resetState()" color="warn" mat-raised-button>Clear</button>
	<button color="primary"
					mat-raised-button
					matStepperNext
					[disabled]="!isCaseHospitalProviderEntryExists">
		Next
		<mat-icon *ngIf="!isCaseHospitalProviderEntryExists"
							class="info-icon"
							[matTooltip]="'Please ensure at least 1 provider is selected'">
			help_outline
		</mat-icon>
	</button>
</div>
